import { forwardRef } from 'react';
import { TextField, TextFieldProps, SxProps, Theme } from '@mui/material';

export type BaseInputProps = Omit<TextFieldProps, 'variant' | 'size' | 'sx' | 'multiline'> & {
    type?: 'text' | 'password' | 'date';
    size?: 'medium' | 'small' | 'medium-sales';
    sx?: SxProps<Theme>;
    multiline?: boolean | undefined;
};

const BaseInput = forwardRef<HTMLDivElement, BaseInputProps>(
    ({ type = 'text', size = 'medium', sx, multiline, ...rest }, ref) => {
        const paddingMedium = '20px';
        const paddingMediumSales = '16px';
        const paddingSmall = '8px 16px';

        const styles = {
            '& .MuiInputBase-input': {
                padding:
                    size === 'medium'
                        ? paddingMedium
                        : size === 'medium-sales'
                          ? paddingMediumSales
                          : paddingSmall,
                lineHeight: '20px',
                fontFamily: 'Assistant, sans-serif',
                fontSize: '15px',
            },
            '& .MuiInputBase-root textarea': { padding: '0' },
            '& .MuiInputBase-root': { padding: multiline ? '20px' : '' },
            '& label': {
                // top: size === 'medium' ? '4px' : '0px',
                // left: size === 'medium' ? '5px' : '0px',
                color: '#686868',
                fontFamily: 'Assistant, sans-serif',
                fontSize: '15px',
                transform:
                    size === 'medium'
                        ? 'translate(20px, 20px)'
                        : size === 'medium-sales'
                          ? 'translate(16px, 16px)'
                          : 'translate(16px, 8px)',
            },
            '& label.MuiInputLabel-shrink': {
                top: '2px',
                left: '0px',
                color: '#282828',
                transform:
                    size === 'medium'
                        ? 'translate(11px, -11px) scale(0.79)'
                        : 'translate(14px, -12px) scale(0.78)',
            },
            '& label.Mui-focused': {
                top: '2px',
                left: '0',
                color: '#282828',
                transform:
                    size === 'medium'
                        ? 'translate(11px, -11px) scale(0.79)'
                        : 'translate(14px, -12px) scale(0.78)',
            },
            '& fieldset': { borderColor: '#e7e7e7' },
            '& .Mui-error .MuiOutlinedInput-notchedOutline ': { borderColor: '#ff2727' },
            '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#282828',
                borderWidth: '1px',
            },
            '.Mui-error.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ff2727',
            },
            '.Mui-error': { color: '#ff2727' },
            ...sx,
        };

        return (
            <TextField
                ref={ref}
                inputRef={rest.inputRef}
                multiline={multiline}
                {...rest}
                variant="outlined"
                type={type}
                sx={styles}
            />
        );
    }
);

export default BaseInput;
